import type { TAccountState } from '@/types/state-types'
import mockUser from './data'
import Config from '@/models/Config'

export default <TAccountState>{
  userId: null,
  accessToken: null,
  expiresIn: null,
  refreshToken: null,
  userRole: null,
  expiringAt: null,
  refreshAttempts: 0,
  profile: mockUser as unknown as TAccountState['profile'],
  profilePromise: null,
  configForm: new Config(),
  isLoadingPriceConfig: false
}
